import React, { type FC } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { theme, embraceTheme } from '@care/material-ui-theme';
import useTestFlags from '@/components/hooks/useTestFlags';

/**
 * Renders the theme provider with the correct theme based on the feature flags
 */
const ThemeProvider: FC = ({ children }) => {
  const { greaterCare } = useTestFlags();
  const isGreaterCareEnabled = greaterCare?.value === 1;

  return (
    <MuiThemeProvider theme={isGreaterCareEnabled ? embraceTheme : theme}>
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
